import { OrderType } from "../../order/constants.js";
import { getBookClubDisplayProducts } from "../selectors/getBookClubDisplayProducts.js";
import { getNextBookClubDispatch, isDispatchBeyondNext, } from "../selectors/getNextBookClubDispatch.js";
import { getNextDispatch } from "../selectors/getNextDispatch.js";
import { getSkipBookDeadline } from "../utils/getSkipBookDeadline.js";
const isDeadlinePassed = (deadline, now) => !!deadline && new Date(deadline) < now;
const isBookVisible = (book) => !!book?.sku && !!book.canBeVisible;
const hasPendingSkip = (periodsToSkip) => !!periodsToSkip;
export const resolveSeriesDelivery = ({ nextBook, renewAt, periodsToSkip, }) => ({
    kind: "series",
    nextBook,
    skipBookDeadline: getSkipBookDeadline(renewAt ?? undefined, OrderType.SERIES_SUBSCRIPTION),
    isSkipped: hasPendingSkip(periodsToSkip),
    canSkip: isBookVisible(nextBook),
});
export const resolveBookSubscriptionDelivery = ({ dispatches, periodsToSkip, isWithoutCreatedOrders, now = new Date(), }) => {
    const nextDispatch = getNextDispatch(dispatches);
    const nextBook = nextDispatch?.products?.[0];
    const skipBookDeadline = getSkipBookDeadline(nextDispatch?.skipBookDeadline, OrderType.BOOK_SUBSCRIPTION);
    const canSkip = !hasPendingSkip(periodsToSkip) &&
        !isDeadlinePassed(skipBookDeadline, now) &&
        !isWithoutCreatedOrders &&
        isBookVisible(nextBook);
    return {
        kind: "bookSubscription",
        nextDispatch,
        nextBook,
        dispatchDate: nextDispatch?.distributionDate,
        skipBookDeadline,
        isSkipped: hasPendingSkip(periodsToSkip),
        canSkip,
    };
};
export const resolveBookClubDelivery = ({ dispatches, renewAt, dispatchBatchCode, holdbackUntil, periodsToSkip, isGiftCampaign, isWithoutCreatedOrders, selectedGiftSkus, giftConfig, now = new Date(), }) => {
    const assignedDispatch = dispatchBatchCode
        ? getNextBookClubDispatch(dispatches, renewAt, dispatchBatchCode)
        : undefined;
    const isInSignupGiftPhase = isGiftCampaign && isWithoutCreatedOrders;
    // Only the club's next dispatch is shown to the member; a later one, after
    // a skip or a pause, stays hidden until the club's next has gone out
    const isBeyondNextDispatch = isDispatchBeyondNext(dispatches, assignedDispatch, now);
    const isOnHoldback = !!holdbackUntil &&
        new Date(holdbackUntil) > now &&
        (!assignedDispatch || isBeyondNextDispatch);
    const pausedUntil = isOnHoldback
        ? (assignedDispatch?.distributionDate ?? holdbackUntil ?? undefined)
        : undefined;
    const nextDispatch = pausedUntil ? undefined : assignedDispatch;
    const dispatchProducts = getBookClubDisplayProducts({
        isBookClub: true,
        shouldDisplayGifts: isInSignupGiftPhase,
        selectedGiftSkus,
        giftConfig,
        dispatchProducts: nextDispatch?.products,
    });
    const visibleDispatchProducts = isBeyondNextDispatch && !isInSignupGiftPhase
        ? []
        : (dispatchProducts ?? [])
            .filter(isBookVisible)
            .sort((a, b) => (a.name ?? "").localeCompare(b.name ?? ""));
    const skipBookDeadline = getSkipBookDeadline(nextDispatch?.skipBookDeadline, OrderType.BOOK_SUBSCRIPTION);
    const canSkip = !hasPendingSkip(periodsToSkip) &&
        !isDeadlinePassed(skipBookDeadline, now) &&
        !!renewAt &&
        !isInSignupGiftPhase &&
        visibleDispatchProducts.length > 0;
    return {
        kind: "bookClub",
        nextDispatch,
        dispatchBatchCode,
        dispatchProducts,
        visibleDispatchProducts,
        dispatchDate: dispatchBatchCode && !pausedUntil ? (renewAt ?? undefined) : undefined,
        skipBookDeadline,
        isInSignupGiftPhase,
        isBeyondNextDispatch,
        isSkipped: hasPendingSkip(periodsToSkip),
        canSkip,
        pausedUntil,
    };
};
